import { FC } from 'react';
import { Box, Image, Stack, Text } from '@chakra-ui/react';
import sortBy from 'lodash/fp/sortBy';
import { useGetSurvey } from '@frx/frx-react-context';
import { sanitizeHtml } from '../../../../utils';
import { CreateTeamModal } from './CreateTeamModal';
import { useLuminateConfig } from '../../../../hooks';
import styles from './CreateTeam.module.scss';
import { CreateTeamImg } from '../../../../assets';

export type CreateTeamProps = {
  headline: string;
  description: string;
  imgPath: string;
};

export const CreateTeam: FC<CreateTeamProps> = ({
  headline,
  description,
  imgPath,
}: CreateTeamProps) => {
  const { heroesFormTeamSurveyId } = useLuminateConfig();
  const { data } = useGetSurvey({ survey_id: Number(heroesFormTeamSurveyId) });
  const questions = data?.survey.surveyQuestions;

  return (
    <Box
      borderColor="brand.monochromatic.200"
      borderRadius="8px"
      boxShadow="0 0 2px 0 #00000095"
      w="full"
    >
      <Box className={styles.container}>
        <Image src={imgPath} w="full" fallbackSrc={CreateTeamImg} />
        <Box fontWeight="semibold" fontSize="xl" className={styles.centered}>
          {headline}
        </Box>
      </Box>

      <Stack pt={6} px={5}>
        <Text fontSize="md" color="brand.monochromatic.900" align="left">
          {sanitizeHtml(description)}
        </Text>
        <Box py={6}>
          <CreateTeamModal
            questions={sortBy('questionOrderNumber', questions)}
          />
        </Box>
      </Stack>
    </Box>
  );
};
